import * as types from '../../action-types';
import {getMyISORepayments as initialState } from "../../initialState";

const getMyISORepayments = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_MY_ISO_REPAYMENTS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_MY_ISO_REPAYMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_MY_ISO_REPAYMENTS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_MY_ISO_REPAYMENTS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getMyISORepayments;

